import React from 'react';

import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';

export interface NameProps {
  name: string;
}

export function Name(props: NameProps) {
  return <div className={DetailsTooltipStyles.EntityName}>{ props.name }</div>;
}

export function Heading(props: NameProps){
  return <div className = {DetailsTooltipStyles.NameMetadata}>{props.name}</div>;
}

